'use strict'

module.exports = {
  INBOUND : 1,
  OUTBOUND : 2,
};
